import { useSelector, useDispatch } from 'react-redux'
import { closeSidebar } from '@slices/uiSlice'
import {
  selectClassicBusy,
  selectFreebetBusy,
  selectFreebetPanels,
  requestFreebetSelection,
} from '@slices/bettingSlice'
import { renderedFreebetId } from '@core/betting/freebetInteractionControls'
import { PANELS } from '@constants/bettingConstants'

/**
 * The menu "Play" action + its disable rule, kept out of the list component so
 * any freebet-list layout just renders a button. Play routes a freebet into
 * panel one (closes the menu; the freebet controller selects it once its list
 * has it). Disabled ONLY when a bet is committed (classic or freebet) or the
 * freebet is already showing in a panel — nothing else, so exactly the freebets
 * you can see in the panels are the ones that can't be re-played.
 */
export const useFreebetPlay = () => {
  const dispatch = useDispatch()
  const classicBusy = useSelector(selectClassicBusy)
  const freebetBusy = useSelector(selectFreebetBusy)
  const panels = useSelector(selectFreebetPanels)

  const betBusy = classicBusy || freebetBusy
  const shownIds = [renderedFreebetId(panels[PANELS.ONE]), renderedFreebetId(panels[PANELS.TWO])]

  const onPlay = (freebet) => {
    dispatch(requestFreebetSelection(freebet.id))
    dispatch(closeSidebar())
  }
  const isPlayDisabled = (freebet) => betBusy || shownIds.includes(freebet?.id)

  return { onPlay, isPlayDisabled }
}
